/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
document.addEventListener("click", function(e) {
    if (e.target.classList.contains("read-more-inline")) {
      const wrapper = e.target.closest(".collection-description");
      const moreEl = wrapper.querySelector(".description-more");
      const ellipsisEl = wrapper.querySelector(".ellipsis");
  
      if (moreEl.hidden) {
        moreEl.hidden = false;
        ellipsisEl.style.display = "none";
        e.target.textContent = "Read Less";
      } else {
        moreEl.hidden = true;
        ellipsisEl.style.display = "inline";
        e.target.textContent = "Read More";
      }
    }
  });

  var IPSTACK_KEY         = "607fd5882d54b0cc6b64d1bd27e36511";

  function GeoCaller(cb) 
  {
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () 
      {
          if ((xhr.readyState == 4) && (xhr.status == 200)) 
          {
              var result = JSON.parse(xhr.responseText);
              console.log("Raw IPStack response:", result);
              cb(result);
          }
      };
      xhr.open("GET", "https://api.ipstack.com/check?access_key=" + IPSTACK_KEY, true);
      xhr.send();
  }
  
  function setCookie(cname, cvalue, exdays)
  {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/; domain=arneclo.com";
  }
  
  function GetCookie(cname)
  {
      let name = cname + "=";
      let ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++)
      {
          let c = ca[i];
          while (c.charAt(0) == " ")
          {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0)
          {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }
  
  function updateCurrencyDisplay(countryCode) {
      let currencyText = "";
  
      switch (countryCode.toUpperCase()) {
          case "IE": // Ireland
              currencyText = "€30";
              break;
          case "US": // United States
              currencyText = "$30";
              break;
          case "NL": // Netherlands
              currencyText = "€30";
              break;
          default:
              return; // Do nothing if the country is not listed
      }
  
      // Update all elements with the class "lion-currency__value"
      document.querySelectorAll(".lion-currency__value").forEach(element => {
          element.textContent = currencyText;
      });
  }
  
  
  function GetParam( param )
  {
      return new URLSearchParams( window.location.search ).get( param );
  }
  
  
  
  function LoadGeoSection( cb )
  {
      var geoContainer = document.querySelector( ".recommendation-modal__backdrop_new" );
      if ( geoContainer )
      {
          console.log( "geo content already loaded :", geoContainer );
          cb( );
      }
      else
      {
          console.log( "loading geo content" );
          if ( window._geoSectionLoadingQ )
          {
              window._geoSectionLoadingQ.push( cb );
          }
          else
          {
              window._geoSectionLoadingQ = [ cb ];
  
              var xhr = new XMLHttpRequest();
              xhr.onreadystatechange = function () 
              {
                  if ( ( xhr.readyState == 4 ) && ( xhr.status == 200 ) ) 
                  {
                      var result = JSON.parse(xhr.responseText);
                      var markup = result[ "arne-locator-popup-content" ];
                      document.body.insertAdjacentHTML( "beforeend", markup );
                      handlePopup();
  
                      // emergency patch
                      try 
                      {
                          var elements = document.querySelectorAll( "#shopify-section-arne-locator-popup-content form[action='/localization'] input[name='return_to']");
                          elements.forEach( function( element )
                          {
                              element.setAttribute( "value", "/" );
                              element.value = "/";
                          } );                      
                      } 
                      catch (error) 
                      {
                        console.log( "ERROR ", error.stack );  
                      }
                    
                      var q = window._geoSectionLoadingQ;
                      window._geoSectionLoadingQ = undefined;
                      q.forEach( function( qcb )
                      {
                          qcb( );
                      } );
                  }
              };
              xhr.open( "GET", window.Shopify.routes.root + "?sections=arne-locator-popup-content", true );
              xhr.send( );
          }        
      }
  }
  
  function ShowGeolocationContent( response )
  {
      LoadGeoSection( function( )
      {
          var countryCode = response.country_code.toLowerCase();
          var target      = document.querySelector( ".locator-popup-country-content[ data-country-code='" + countryCode + "' ]" );
          target.classList.remove( "hidden" );
      } );
  }
  function setDataOnBody( code )
  {
      var body = document.querySelector( "body" );
      body.setAttribute( "data-market", code.toLowerCase() );
  }
  
  function HandleArneGeolocation( )
  {   
      var countryForcedParam = GetParam( "forcecountry" );
      var cachedCountryCode  = GetCookie( "arne_geo_country_code" );
  
      if ( countryForcedParam == null || countryForcedParam == "" || countryForcedParam == undefined )
      {
          if( cachedCountryCode )
          {
              countryForcedParam = true;
              setDataOnBody( cachedCountryCode );
              updateCurrencyDisplay(response.country_code);
          }
      }
      if( !countryForcedParam )
      {
          GeoCaller( function( response )
          {
              setCookie( "arne_geo_country_code", response.country_code, 0.25 );
              setDataOnBody( response.country_code );
              updateCurrencyDisplay(response.country_code);
              
              if (response.country_code !== "GB")
              {
                  LoadGeoSection( function( )
                  {
                      ShowGeolocationContent( response );
                      HandleGeolocationPopupForm( response.country_code );
  
                      var backdrop        = document.querySelector('.recommendation-modal__backdrop_new');
                      var locationsPopup  = document.querySelector('.locater-popup-locations');
                      backdrop.style.display = 'block';
                      locationsPopup.style.display = 'flex';
                  } );
              }
          });   
      }
      else
      {
          if (cachedCountryCode !== "GB")
          {
              LoadGeoSection( function( )
              {
                  ShowGeolocationContent( { "country_code" : cachedCountryCode } );
                  HandleGeolocationPopupForm( cachedCountryCode );
  
                  var backdrop        = document.querySelector('.recommendation-modal__backdrop_new');
                  var locationsPopup  = document.querySelector('.locater-popup-locations');
                  backdrop.style.display = 'block';
                  locationsPopup.style.display = 'flex';
              } );
          }
      }
  }
  
  function HandleGeolocationPopupForm( countryCode ) 
  {
      console.log("HandleGeolocationPopupForm Country Code:", countryCode);
      var dropdown   = document.querySelector('.locator-popup-dropdown');
      var form       = document.querySelector('.localization-form');
  
      if ( dropdown && form ) 
      {
          var options = dropdown.options;
          if ( !dropdown.dataset.initialized ) 
          {
              for ( var i = 0; i < options.length; i++ ) 
              {
                  if (options[i].value.toLowerCase() === countryCode.toLowerCase()) 
                  {
                      dropdown.selectedIndex = i;
                      break;
                  }
              }
              dropdown.dataset.initialized = true;
          }
  
          var continueBtn = document.querySelector('.locator-first-btn');
          if (continueBtn) 
          {
              continueBtn.addEventListener( 'click', function (e) 
              {
                  e.preventDefault();
                  form.submit();
              });
          }
  
          dropdown.addEventListener('change', function () 
          {
              var selectedCountryCode = dropdown.options[dropdown.selectedIndex].value.toLowerCase();
              updateGeolocationContent(selectedCountryCode);
          });
      }
  }
  
  
  function updateGeolocationContent(countryCode) 
  {
      var countryContent = document.querySelectorAll('.locator-popup-country-content');
      countryContent.forEach(function(content) 
      {
          if (content.dataset.countryCode === countryCode) 
          {
              content.classList.remove('hidden');
          } else {
              content.classList.add('hidden');
          }
      });
  }
  
  window.addEventListener("load", function () 
  {
      if ( !GetCookie("arne_geo_country_code") ) 
      {
          HandleArneGeolocation();
      }
  
      // removed 3/11/24 : the backdrop and popup have element-level display: none styling and no "hidden" class, so these calls don't seem to do anything !
      if ( GetCookie("arne_geo_country_code") !== "GB" )
      {
         LoadGeoSection( function( )
         {
             var backdrop        = document.querySelector('.recommendation-modal__backdrop_new');
             var locationsPopup  = document.querySelector('.locater-popup-locations');
             
             backdrop.classList.remove('hidden');
             locationsPopup.classList.remove('hidden');
         } );
      }
  });
  
  function handlePopupShow( command, mainPopup, locationsPopup ) 
  {
      var mainPopupDisplay         = "none";
      var locationsPopupDisplay    = "flex";
  
      if ( command === "show" ) 
      {
          mainPopupDisplay         = "flex";
          locationsPopupDisplay    = "none";
      }
  
      mainPopup.style.display      = mainPopupDisplay;
      locationsPopup.style.display = locationsPopupDisplay;
  }
  
  function handlePopup() {
    var closePopupBtn           = document.querySelector('.locater-popup-close');
    var changeLocationBtns      = document.querySelectorAll('.locater-popup-change-location');
    var cancelLocationChangeBtn = document.querySelector('.locater-popup-cancel');
    var backdrop                = document.querySelector('.recommendation-modal__backdrop_new');
    var mainPopup               = document.querySelector('.locator-popup-main');
    var locationsPopup          = document.querySelector('.locater-popup-locations');
  
    if (closePopupBtn) {
      console.log("closePopupBtn found");
      closePopupBtn.addEventListener('click', function () {
        console.log("Close button clicked");
        backdrop.style.display = 'none';
        locationsPopup.style.display = 'none';
      });
    } else {
      console.warn("closePopupBtn NOT found at time of binding");
    }
  
    if (changeLocationBtns && changeLocationBtns.length) {
      changeLocationBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          console.log("Change location clicked");
          handlePopupShow("hide", mainPopup, locationsPopup);
        });
      });
    }
  
    if (cancelLocationChangeBtn) {
      cancelLocationChangeBtn.addEventListener('click', function () {
        console.log("Cancel clicked");
        handlePopupShow("show", mainPopup, locationsPopup);
      });
    }
  }
  
  document.addEventListener('DOMContentLoaded', function () 
  {
      handlePopup();
      initializeGorgiasContactForm();
  });

  // Initialize Gorgias Contact Form
  function initializeGorgiasContactForm() {
    // Load the Gorgias contact form loader script
    const script = document.createElement('script');
    script.src = 'https://contact.gorgias.help/api/contact-forms/loader.js?uid=k556uwzi&locale=en-US';
    script.async = true;
    
    script.onload = function() {
      // Wait for GorgiasWebWidget to be available after script loads
      const checkGorgias = setInterval(function() {
        const formContainer = document.querySelector(".gorgias-contact-popup[data-gorgias-contact-form='container']");
        
        if (formContainer && typeof GorgiasWebWidget !== 'undefined' && typeof GorgiasWebWidget.init === 'function') {
          GorgiasWebWidget.init(formContainer);
          clearInterval(checkGorgias);
          console.log('Gorgias contact form initialized');
        }
      }, 100);

      // Stop checking after 10 seconds
      setTimeout(function() {
        clearInterval(checkGorgias);
      }, 10000);
    };
    
    script.onerror = function() {
      console.error('Failed to load Gorgias contact form script');
    };
    
    document.head.appendChild(script);
  }

  // Contact Sidebar Toggle Handler
  document.addEventListener('click', function(e) {
    if (e.target.closest('.contact_sidebar_toggle')) {
      const contactSidebar = document.querySelector('.contact_sidebar');
      const gorgiasPopup = document.querySelector('.gorgias-contact-popup');
      const body = document.body;

      if (contactSidebar) {
        contactSidebar.classList.toggle('opened');
      }
      
      if (gorgiasPopup) {
        gorgiasPopup.classList.toggle('active');
      }

      if (!body.classList.contains('c_sidebar_opened')) {
        body.classList.add('c_sidebar_opened');
      }

      if (body.classList.contains('menu_opened')) {
        body.classList.remove('menu_opened');
      }
    }

    // Close contact sidebar when clicking overlay
    if (e.target.classList.contains('custom_sidebar_overlay')) {
      const contactSidebar = document.querySelector('.contact_sidebar');
      const gorgiasPopup = document.querySelector('.gorgias-contact-popup');
      const body = document.body;

      if (contactSidebar) {
        contactSidebar.classList.remove('opened');
      }
      
      if (gorgiasPopup) {
        gorgiasPopup.classList.remove('active');
      }

      body.classList.remove('c_sidebar_opened');
    }

    // Close button handler
    if (e.target.closest('.sidebar_closer') || e.target.closest('.mobile-gorgias-x')) {
      const contactSidebar = document.querySelector('.contact_sidebar');
      const gorgiasPopup = document.querySelector('.gorgias-contact-popup');
      const body = document.body;

      if (contactSidebar) {
        contactSidebar.classList.remove('opened');
      }
      
      if (gorgiasPopup) {
        gorgiasPopup.classList.remove('active');
      }

      body.classList.remove('c_sidebar_opened');
    }
  });
   